// extracted by mini-css-extract-plugin
export default {"tasksWrapper":"styles_tasksWrapper__h1T2R","newTaskBtn":"styles_newTaskBtn__i8D87","newTaskButtonMobile":"styles_newTaskButtonMobile__xwT5n"};